import * as React from 'react';
var PickerContext = /*#__PURE__*/React.createContext(null);
export default PickerContext;